<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function toggleGroupMaterials(value: boolean) {
  await settingsStore.set('materialGroupAddedItems', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.materialGroupAddedItems"
    :label="t('settings.materials.groupMaterials')"
    :description="t('settings.materials.groupMaterialsDescription')"
    @change="toggleGroupMaterials"
  />
</template>
